import React from 'react';
import { useDispatch } from 'react-redux';
import {
  Box,
  HStack,
  Popover,
  PopoverArrow, PopoverBody,
  PopoverContent,
  PopoverTrigger,
  VStack
} from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { generateS3GetUrl } from '../../../../../redux/modules/documents';
import { getDateString, isPast } from '../../../../../utils/dateUtil';
import { getStatusDisplayName } from '../../../../../utils/statusUtil';

const DocumentCell = ({ value: { data: itemsOrInsureds } }) => {
  const dispatch = useDispatch();
  const documents = itemsOrInsureds.reduce((pols, item) => ([...pols, ...(item.insuranceDocuments || [])]), []);

  const handleDocClick = async docId => {
    const getUrl = await dispatch(generateS3GetUrl(docId));
    window.open(getUrl, '_blank');
  };

  return (
    <VStack fontSize="sm" maxH={300} overflow="auto">
      {documents.map(document => (
        <Popover
          key={document.id}
          placement="top-start"
          trigger="hover"
        >
          <PopoverTrigger>
            <HStack cursor="pointer" key={document.id} minWidth={300} width="100%">
              <Box
                flexBasis="50%"
                textAlign="right"
                whiteSpace="nowrap"
                onClick={() => handleDocClick(document.id)}
              >
                {document.displayName}
              </Box>
              <Box
                color={isPast(document.expiresAt) ? 'red' : 'inherit'}
                flexBasis="50%"
                textAlign="left"
                whiteSpace="nowrap"
              >
                {getDateString(document.expiresAt, 'MM/DD/YYYY')}
              </Box>

            </HStack>
          </PopoverTrigger>
          <PopoverContent>
            <PopoverArrow />
            <PopoverBody p={3}>
              <HStack justifyContent="space-between" width="100%">
                <Box fontSize="sm" mr={3} whiteSpace="nowrap">Type</Box>
                <Box color="grey" fontSize="sm" whiteSpace="nowrap">{document.type.displayName}</Box>
              </HStack>
              <HStack justifyContent="space-between" width="100%">
                <Box fontSize="sm" mr={3} whiteSpace="nowrap">Status</Box>
                <Box color="grey" fontSize="sm" whiteSpace="nowrap">{getStatusDisplayName(document.status)}</Box>
              </HStack>
            </PopoverBody>
          </PopoverContent>
        </Popover>
      ))}
    </VStack>
  );
};

DocumentCell.propTypes = {
  value: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({
      properties: PropTypes.arrayOf(PropTypes.shape({
        type: PropTypes.string,
        value: PropTypes.string
      }))
    }))
  })
};

export default DocumentCell;
